
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { isNullOrEmptyString } from '../../../../_helpers';

@Component({
    selector: 'button-pop-product-compositions',
    templateUrl: './button-product-compositions.component.html',
    styleUrls: ['./button-product-compositions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ButtonProductCompositionsComponent implements OnInit {

  //#region Données en entrée

    //nom du produit
    private _productName: string = null;
    @Input()
    set ProductName(_iProductName: string) {
        this._productName = _iProductName;
    }
    get ProductName(): string {
        return this._productName;
    }

    /**unité du produit concerné conditionnera l'unité de composition (cas des litres) */
    private _productUnit: string = null;
    @Input()
    set ProductUnit(_iProductUnit: string) {
        this._productUnit = _iProductUnit;
        
    }
   get ProductUnit(): string {
        return this._productUnit;
    }

     //Préfixe du tooltip sur ptoduit
    private _pfxTooltip: string = "Composition de l'engrais ";
   //Retourne le tooltip formaté sur la div
      get PopinTooltip() {
          if (!isNullOrEmptyString(this._productName)) {
              return `${this._pfxTooltip} :  ${this._productName}`;
          } else {
              return this._pfxTooltip;
          }
      }

    /**
     * Teneurs du produit
     */
    private _productComposition: any[] = null;
    @Input()
    set ProductCompositions(_iProductComposition: any[]) {
        this._productComposition = _iProductComposition;
    }
    get ProductCompositions(): any[] {
        return this._productComposition;
    }   
    //#endregion

    ngOnInit() {

    };
}